import {
    ADVERTISEMENT_GET,
    ADVERTISEMENT_LOADING_STATUS,
    ADVERTISEMENT_CLEAR
} from '@/store/advertisement/types'

const initialState = {
    isLoading: false,
    banner: null
}

export const state = { ...initialState }

export default {
    [ADVERTISEMENT_LOADING_STATUS]: (state, status) => {
        state.isLoading = status
    },
    [ADVERTISEMENT_GET]: (state, payload) => {
        state.banner = payload
    },
    [ADVERTISEMENT_CLEAR]: (state) => {
        state.banner = null
    }
}